// extracted by mini-css-extract-plugin
module.exports = {"centered":"_a02f349","light":"_9eb1bca","dark":"_74778c8"};